import { Route, Routes } from 'react-router';

import { UpdDocumentPage } from '@/pages/upd/UpdDocumentPage';
import { UpdListPage } from '@/pages/upd/UpdListPage';

/** Раздел «УПД»: загрузка и очередь, страница проверки /upd/:id. */
export function UpdSection() {
  return (
    <Routes>
      <Route index element={<UpdListPage />} />
      <Route path=":docId" element={<UpdDocumentPage />} />
    </Routes>
  );
}
